'use strict';


(function() {
	angular.module('onboarding.common')
		.directive('cobEscape',
			function() {
				return function(scope, element, attrs) {
					element.bind('keydown keypress',
						function(event) {
							if (event.which === 27) {
								scope.$apply(function() {
									event.preventDefault();
									scope.$eval(attrs.cobEscape, { 'event': event });
								});

								return false;
							}
						});
				};
			});
})();
